import { defineStore } from 'pinia';

export const useLayoutStore = defineStore('layout', {
  state: (): LayoutState => ({
    menuOpen: typeof window !== 'undefined' ? window.innerWidth >= 1024 : true,
    isModalOpen: false,
    modalType: 'closed',
    previousModalType: 'closed',
    authInitialTab: 'login',
    afterLoginRedirect: '',
    isModalChallengeOpen: false,
    isModalLegalAgeOpen: true,
    chatIsOpen: false,
    footerDescription: '',
    toaster: {
      is_open: false,
      position: 'bottom-right',
      type: 'default',
      time: 5000,
      message: '',
    },
    sideBar: {
      width: 0,
    },
    topbar: {
      isVisible: false,
      height: 0,
    },
    header: {
      height: 0,
    },
    horizontalMenu: {
      height: 0,
    },
    bottomMenu: {
      height: 0,
    },
    isMenuAnimating: false, // New state to track menu animation
    isCashbackMenuOpen: false, // Novo estado para blur do cashback
    isDarkTheme: false,
  }),
  actions: {
    setCashbackMenuOpen(value: boolean) {
      this.isCashbackMenuOpen = value;
    },
    toggleModal(type?: ModalType) {
      this.isModalOpen = !this.isModalOpen;

      if (type) {
        this.modalType = type;
      }
    },
    openModal(type: ModalType) {
      this.isModalOpen = true;

      if (type) {
        this.modalType = type;
      }
    },
    selectModalType(type: ModalType) {
      if (type) this.modalType = type;
    },
    setAuthInitialTab(tab: 'login' | 'register') {
      this.authInitialTab = tab;
    },
    closeModal() {
      this.isModalOpen = false;
      this.modalType = 'closed';
      this.previousModalType = 'closed';
      this.authInitialTab = 'login';
    },
    toggleMenuOpen() {
      this.menuOpen = !this.menuOpen;
    },
    openMenu() {
      this.menuOpen = true;
    },
    closeMenu() {
      this.menuOpen = false;
    },
    setMenuAnimating(value: boolean) {
      this.isMenuAnimating = value;
    },
    openToaster(
      options: {
        message?: string;
        type?: toasterType;
        time?: number;
        position?: toasterPosition;
      } = {},
    ) {
      const { message, type, time, position } = options;

      this.toaster.is_open = false;

      const isMobile =
        typeof window !== 'undefined' ? window.innerWidth < 1024 : false;

      const defaultPosition = isMobile ? 'bottom-right' : 'top-right';

      setTimeout(() => {
        this.toaster.position = position || defaultPosition;
        this.toaster.type = type || 'default';
        this.toaster.message = message || '';
      }, 230);

      setTimeout(() => {
        this.toaster.time = time || 6000;
        this.toaster.is_open = true;
      }, 340);
    },
    setTopBarHeight(height: number) {
      this.topbar.height = height;
    },
    openTopBar() {
      this.topbar.isVisible = true;
    },
    closeTopBar() {
      this.topbar.isVisible = false;
      this.topbar.height = 0;
    },
    setSideBarWidth(width: number) {
      this.sideBar.width = width;
    },
    setHeaderHeight(height: number) {
      this.header.height = height;
    },
    setHorizontalMenuHeight(height: number) {
      this.horizontalMenu.height = height;
    },
    setBottomMenuHeight(height: number) {
      this.bottomMenu.height = height;

      if (import.meta.client) {
        document.documentElement.style.setProperty(
          '--bottomMenuHeight',
          `${height}px`,
        );
      }
    },
    openChallenge() {
      this.isModalChallengeOpen = true;
    },
    closeChallenge() {
      this.isModalChallengeOpen = false;
    },
    openLegalAge() {
      this.isModalLegalAgeOpen = true;
    },
    closeLegalAge() {
      this.isModalLegalAgeOpen = false;
    },
    openHelp() {
      // Guarda modal anterior e abre ajuda
      this.previousModalType = this.modalType;
      this.isModalOpen = true;
      this.modalType = 'help';
    },
    closeHelp() {
      // Volta para o modal anterior se existir, senão fecha
      if (this.previousModalType && this.previousModalType !== 'closed') {
        this.modalType = this.previousModalType;
        this.previousModalType = 'closed';
        this.isModalOpen = true;
      } else {
        this.closeModal();
      }
    },
    toggleChatOpen() {
      this.chatIsOpen = !this.chatIsOpen;
    },
    closeChat() {
      this.chatIsOpen = false;
    },
    setFooterDescription(description: string) {
      this.footerDescription = description;
    },
    setDarkTheme(value: boolean) {
      this.isDarkTheme = value;
    },
  },
});
